import { ComponentProps } from 'react';
import TagBox from 'devextreme-react/tag-box';
export function ChartFilterTagBox(props: ComponentProps<typeof TagBox>) {
    return (
        <TagBox
            {...props}
            className={`fs-chart-filter-tagbox ${props.className ?? ''}`}
            dropDownOptions={{ maxHeight: 280, ...props.dropDownOptions }}
        />
    );
}